import { useSelector } from 'react-redux';
import { DashboardState } from '../../../models';

export default function useGetAircraftStandardField<T>(key: string, id: string): T {
  const {
    aircraft: { aircraftMap },
  } = useSelector((state: DashboardState) => state);

  const foundStandardField = aircraftMap.get(id)?.standard_fields?.[key];
  return foundStandardField as T;
}
